import { Component, HostListener, OnChanges, OnInit } from '@angular/core';
import { DeviceService } from 'src/app/services/devices/device.service';
import { UserService } from 'src/app/services/user/user.service';
import { Router } from '@angular/router';
import { ConnectorState } from 'src/assets/js/constants';
import { TranslateService } from '@ngx-translate/core';

import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import {
  isAncFamilyDevice,
  isRelaySchedulerSerial,
  getRelayDeviceImage,
} from 'src/app/services/devices/device-type.util';
import calculoZoom from './calculoDistancias';
import * as L from 'leaflet';
import 'leaflet-control-geocoder';
import 'leaflet.markercluster';




@Component({
    selector: 'dashboard-cmp',
    //moduleId: module.id,
    templateUrl: 'dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  showDevices = false;
  linkedDevices: any[] = [];
  data: any[] = [];
  myZoom: number = 6;
  view: 'groups' | 'devices';
  breadCrumb: string[] = ['home'];
  userName: string = '';
  userRole: string = '';
  userEmail: string = '';
  devices: any[] = [];
  selectedSetting: 'list' | 'map' | '';
  locations: any[] = [];
  position = { lat: 40.45987, lng: -3.691145 };
  showList: boolean = true;
  info: boolean = false;

  dataSource: any[] = [];
  search = '';
  selectDevice: 'viaris' | 'xeo' | 'others' | 'all' = 'viaris';
  // selectView : 'list' | 'map' = 'map';

  map: any;
  marker: any;
  popup: any;
  infoWindow: any;
  homeClone: HTMLElement | null = null;
  listClone: HTMLElement | null = null;
  serial: string = '';
  indice: number;

  totalPower = 0;
  homePower = 0;
  fvPower = 0;
  evsePower = 0;
  battEnergy = 0;
  battPercent = 0;
  solarInfo: any;

  statesPermission = [5, 6, 7];
  permission: any[] = [];
  allStates = ConnectorState;
  connectorsState: any[] = [];
  connectors: any;
  type: any;
  elementInfo: any;
  channels: any = {};

  loadingInfo: boolean = true;
  loading: boolean = true;
  dataInitialized: boolean = false;
  batteryCharging = false;

  divIcono = document.createElement('h5');
  icono =
    '<div class="text-center m-2 "><svg xmlns="http://www.w3.org/2000/svg" height="30px"  width="30px" fill="currentColor" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"/></svg></div> ';
  iconoANC =
    '<div class="text-center m-1 "><svg xmlns="http://www.w3.org/2000/svg" height="30px"  width="30px" fill="currentColor" viewBox="0 0 600 600"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M420.9 448C428.2 425.7 442.8 405.5 459.3 388.1C492 353.7 512 307.2 512 256C512 150 426 64 320 64C214 64 128 150 128 256C128 307.2 148 353.7 180.7 388.1C197.2 405.5 211.9 425.7 219.1 448L420.8 448zM416 496L224 496L224 512C224 556.2 259.8 592 304 592L336 592C380.2 592 416 556.2 416 512L416 496zM312 176C272.2 176 240 208.2 240 248C240 261.3 229.3 272 216 272C202.7 272 192 261.3 192 248C192 181.7 245.7 128 312 128C325.3 128 336 138.7 336 152C336 165.3 325.3 176 312 176z"/></svg></div> ';
  iconoCTM =
    '<div class="text-center m-1 "><svg xmlns="http://www.w3.org/2000/svg" height="30px"  width="30px" fill="currentColor" viewBox="0 0 600 600"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M169.3 256C196.8 163.5 282.5 96 384 96L448 96C465.7 96 480 110.3 480 128C480 145.7 465.7 160 448 160L384 160C318.4 160 262 199.5 237.3 256L368 256C381.3 256 392 266.7 392 280C392 293.3 381.3 304 368 304L224.8 304C224.3 309.3 224 314.6 224 320C224 325.4 224.3 330.7 224.8 336L368 336C381.3 336 392 346.7 392 360C392 373.3 381.3 384 368 384L237.3 384C262 440.5 318.4 480 384 480L448 480C465.7 480 480 494.3 480 512C480 529.7 465.7 544 448 544L384 544C282.5 544 196.8 476.5 169.3 384L136 384C122.7 384 112 373.3 112 360C112 346.7 122.7 336 136 336L160.6 336C159.9 325.5 159.9 314.5 160.6 304L136 304C122.7 304 112 293.3 112 280C112 266.7 122.7 256 136 256L169.3 256z"/></svg></div> ';
  divLoading =
    '<div class="text-center mb-1">  <div id="loading"  class="spinner-border text-primary spinner" role="status" ><span class="visually-hidden"></span></div> </div> ';
  divTitle = document.createElement('h5');

  positionObservable;

  constructor(
    private _devices: DeviceService,
    private _user: UserService,
    private _router: Router,
    private _translate: TranslateService,
    private _dashboardService: DashboardService
  ) {
    _dashboardService.getLocation().subscribe(() => {
      // if (this.selectedSetting === 'map') {
      //   this.initMap();
      // }
    });
    }


  ngOnInit() {
    this._dashboardService.resetBreadCrumbs();
    this._dashboardService.getModoDashboard().subscribe((data) => {
      this.selectedSetting = data;
    });

    // console.log('valor inicial de selectedSetting', this.selectedSetting);

    if (this.selectedSetting == '') {
      localStorage.getItem('dashboardOpt') === 'lista'
        ? ((this.showList = true), (this.selectedSetting = 'list'))
        : ((this.showList = false), (this.selectedSetting = 'map'));
      this._dashboardService.setModoDashboard(this.selectedSetting);
    }

    if (this.selectedSetting == 'list') {
      this.showList = true;
    }

    if (this.selectedSetting == 'map') {
      this.showList = false;
    }

    this._user.getUserInfo().subscribe((userInfo) => {
      this.userEmail = userInfo.email || '';
      this.userName = userInfo.name || '';
      this.userRole = userInfo.role || '';

      this.getGroupsInfo(this.showList);
      if (!this.showList) this.getAllDevices();

      // Mark data as initialized once we have user info
      this.dataInitialized = true;
    });

    this._dashboardService.getViewDashboard().subscribe((data) => {
      this.view = data;
      if (this.userRole && this.userRole != 'admin' && !this.hasGroupSubscription())
        this.view = 'devices';
      if (this.view == 'devices' && this.dataInitialized) {
        if (!this.devices || this.devices.length == 0) {
          this.getAllDevices();
        }
      }
    });

    setTimeout(() => {
      this.loading = !this.loading;
      if (this.showList == false)
        try {
          this.initMap();
        } catch (error) {
          alert('Error: ' + error);
          this.showList = true;
        }
    }, 1900);
  }

  getAllDevices() {
    this._devices?.getDevices().subscribe((devices) => {
      if (devices) {
        this.devices = devices;
        if (this.devices.length == 1) this.goToDevice(this.devices[0].serial);
        this.geolocation();
        this.locations = [];
        for (let index = 0; index < this.devices.length; index++) {
          if (this.devices[index].coords) {
            var coords = this.parseData(this.devices[index].coords);
            this.locations.push({
              position: {
                lat: parseFloat(coords[0]),
                lng: parseFloat(coords[1]),
              },
              title: this.devices[index].serial,
              name: this.devices[index].name,
              alive: this.devices[index].alive,
              sub_type: this.devices[index].sub_type,
              firmware_version_name: this.devices[index].firmware_version_name,
            });
          }
        }
      }
    });
  }

  getGroupsInfo(info = false) {
    this._devices.getGroups('onlyParents').subscribe(
      (updatedGroups) => {
        this.data = updatedGroups; // Guardar la información actualizada
        if (info) {
          updatedGroups.forEach((group, index) => {
            this._devices.getGroup(group.alias).subscribe(
              (updatedGroup) => {
                this.data[index] = updatedGroup;
              },
              (error) => {
                console.error('Error fetching data:', error);
              }
            );
          });
        }
        this.dataSource = this.data;
        this.dataSource.sort(
          (a, b) =>
            new Date(a.date_build).getTime() - new Date(b.date_build).getTime()
        );
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  clickDevice(device) {
    this._devices?.setUserDevice(this.userEmail);
    setTimeout(() => {
      this._router.navigate(['/dashboard/device', device]);
    }, 200);
  }

  async initMap(): Promise<void> {

    const mapContainer = document.getElementById('map-container');
    if (!mapContainer) return;

    // 1. Elimina el mapa anterior si existe en el DOM
    const oldMap = document.getElementById('map');
    if (oldMap && oldMap.parentNode) {
      oldMap.parentNode.removeChild(oldMap);
    }

    // 2. Crea el nuevo contenedor del mapa
    const newMapDiv = document.createElement('div');
    newMapDiv.setAttribute('id', 'map');
    newMapDiv.setAttribute(
      'style',
      'height: calc(100vh - 64px); width: 100%;'
      // 'height: 100vh ; width: 100%;'
    );

    mapContainer.appendChild(newMapDiv);

    this._dashboardService.getLocation().subscribe((data) => {
      if (!document.getElementById('map')) return;
      this.positionObservable = data;
    });

    this._dashboardService.getZoom().subscribe((data) => (this.myZoom = data));
    this.myZoom = calculoZoom(this.locations)
    this._dashboardService.setZoom(this.myZoom)


    // Elimina el mapa anterior si existe
    if (this.map) {
      this.map.remove();
      this.map = null;
    }

    this.map = L.map('map', {
      scrollWheelZoom: true, // Desactiva zoom con rueda del ratón
      zoomControl: false, // Oculta los controles por defecto
      // attributionControl: false
    }).setView(
      [this.positionObservable.lat, this.positionObservable.lng],
      this.myZoom
    );

    // Añade capa base
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(this.map);

    // Geocoder
    const geocoderControl = (L.Control as any)
      .geocoder({
        defaultMarkGeocode: false,
        position: 'topleft',
      })
      .on('markgeocode', (e) => {
        const center = e.geocode.center;
        this.map.setView(center, 17);
        L.marker(center).addTo(this.map);
      })
      .addTo(this.map);

    setTimeout(() => {
      const geocoderContainer = document.querySelector(
        '.leaflet-control-geocoder'
      ) as HTMLElement;
      if (geocoderContainer) {
        geocoderContainer.classList.add('leaflet-control-geocoder-expanded');
        const input = geocoderContainer.querySelector(
          'input'
        ) as HTMLInputElement;
        if (input) input.focus();
      }
    }, 300);

    // Controles personalizados (home + list)
    const customControl = L.Control.extend({
      options: {
        position: 'topright',
      },
      onAdd: () => {
        const container = L.DomUtil.create('div');

        const homeOriginal = document.getElementById('home') as HTMLElement;
        const listOriginal = document.getElementById('list') as HTMLElement;

        if (!this.homeClone && homeOriginal) {
          this.homeClone = homeOriginal.cloneNode(true) as HTMLElement;
          homeOriginal.style.display = 'none';
          this.homeClone.addEventListener('click', () => homeOriginal.click());
        }

        if (!this.listClone && listOriginal) {
          this.listClone = listOriginal.cloneNode(true) as HTMLElement;
          listOriginal.style.display = 'none';
          this.listClone.addEventListener('click', () => listOriginal.click());
        }

        // Agrega los clones al mapa cuando se crea por segunda vez
        if (this.homeClone) container.appendChild(this.homeClone);
        if (this.listClone) container.appendChild(this.listClone);

        return container;
      },
    });

    this.map.addControl(new customControl());

    setTimeout(() => this.map.invalidateSize(), 0);
    setTimeout(() => this.map.invalidateSize(), 250);

        // Crear grupo de clustering para marcadores
    const markerClusterGroup = (L as any).markerClusterGroup({
      // Configuración del clustering
      maxClusterRadius: 80, // Radio máximo para agrupar marcadores
      spiderfyOnMaxZoom: true, // Desagrupar al hacer zoom máximo
      showCoverageOnHover: false, // No mostrar área de cobertura al hover
      zoomToBoundsOnClick: true, // Zoom automático por defecto al hacer click
      // Personalizar el icono del cluster
      iconCreateFunction: function(cluster) {
        const childCount = cluster.getChildCount();
        let clusterClass = 'marker-cluster-';

        if (childCount < 10) {
          clusterClass += 'small';
        } else if (childCount < 100) {
          clusterClass += 'medium';
        } else {
          clusterClass += 'large';
        }

        return new L.DivIcon({
          html: '<div><span>' + childCount + '</span></div>',
          className: 'marker-cluster ' + clusterClass,
          iconSize: new L.Point(40, 40)
        });
      }
    });

    await this.addInfoChannel();

    // Marcadores
    this.locations.forEach( ({ position, title, name }, i) => {
      let backgroundColor = '';
      let circleColor = '';
      const channel = this.locations[i].channelStat ?? null;
      const isAlive = this.locations[i].alive !== 0;
      if( !isAncFamilyDevice({ sub_type: this.locations[i].sub_type, serial: title })) {
         backgroundColor = isAlive ? '#33c88c' : '#ff4c4c';
         circleColor = isAlive ? '#269568' : '#a50404';
      }
      if( isAncFamilyDevice({ sub_type: this.locations[i].sub_type, serial: title })) {
        if ((channel?.c2stat == 2 || channel?.c2stat == 3) || (channel?.c1stat == 2 || channel?.c1stat == 3)) {
         backgroundColor = '#f7d21a';
         circleColor = '#CAA907';
        }else{
          backgroundColor = '#808080';
          circleColor = '#696969';
        }
      }

      var iconHtml = `
        <svg width="30" height="40" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
          <!-- Gota de fondo -->
          <path fill="${backgroundColor}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"/>

          <!-- Círculo interior -->
          <circle cx="13" cy="13" r="10" fill="${circleColor}" />

          <!-- Icono SVG insertado dentro del círculo -->
          <g transform="translate(10, 6) scale(0.018, 0.024)">
            <path fill="white" d="M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"/>
          </g>
        </svg>
        `;

      if(title.startsWith('A2') || title.startsWith('XLUM') || title.startsWith('M1')) {
        iconHtml = `
        <svg width="30" height="40" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
          <!-- Gota de fondo -->
          <path fill="${backgroundColor}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"/>

          <!-- Círculo interior -->
          <circle cx="13" cy="13" r="10" fill="${circleColor}" />

          <!-- Icono SVG insertado dentro del círculo -->
          <g transform="translate(5,5) scale(0.024, 0.024)">
            <path fill="#ffffff" d="M420.9 448C428.2 425.7 442.8 405.5 459.3 388.1C492 353.7 512 307.2 512 256C512 150 426 64 320 64C214 64 128 150 128 256C128 307.2 148 353.7 180.7 388.1C197.2 405.5 211.9 425.7 219.1 448L420.8 448zM416 496L224 496L224 512C224 556.2 259.8 592 304 592L336 592C380.2 592 416 556.2 416 512L416 496zM312 176C272.2 176 240 208.2 240 248C240 261.3 229.3 272 216 272C202.7 272 192 261.3 192 248C192 181.7 245.7 128 312 128C325.3 128 336 138.7 336 152C336 165.3 325.3 176 312 176z"/>
          </g>
        </svg>
        `;
      }

      if(title.startsWith('CTM')) {
        iconHtml = `
        <svg width="30" height="40" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
          <!-- Gota de fondo -->
          <path fill="${backgroundColor}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"/>

          <!-- Círculo interior -->
          <circle cx="13" cy="13" r="10" fill="${circleColor}" />

          <!-- Icono SVG insertado dentro del círculo -->
          <g transform="translate(4,5) scale(0.026, 0.024)">
            <path fill="#ffffff" d="M169.3 256C196.8 163.5 282.5 96 384 96L448 96C465.7 96 480 110.3 480 128C480 145.7 465.7 160 448 160L384 160C318.4 160 262 199.5 237.3 256L368 256C381.3 256 392 266.7 392 280C392 293.3 381.3 304 368 304L224.8 304C224.3 309.3 224 314.6 224 320C224 325.4 224.3 330.7 224.8 336L368 336C381.3 336 392 346.7 392 360C392 373.3 381.3 384 368 384L237.3 384C262 440.5 318.4 480 384 480L448 480C465.7 480 480 494.3 480 512C480 529.7 465.7 544 448 544L384 544C282.5 544 196.8 476.5 169.3 384L136 384C122.7 384 112 373.3 112 360C112 346.7 122.7 336 136 336L160.6 336C159.9 325.5 159.9 314.5 160.6 304L136 304C122.7 304 112 293.3 112 280C112 266.7 122.7 256 136 256L169.3 256z"/>
          </g>
        </svg>
        `;
      }

      const myIcon = L.divIcon({
        className: '',
        html: iconHtml,
        iconSize: [30, 40],
        iconAnchor: [15, 40],
      });

      const marker = L.marker(position, { icon: myIcon });
      // marker.bindTooltip(title);
      marker.bindTooltip(name);
      marker.on('click', () => {
        this.info = false;
        this.loadingInfo = true;
        this.popup = L.popup()
          .setLatLng(marker.getLatLng())
          .setContent(name + `<br>` + `<small>` + title + `</small>`  + this.divLoading)
          .openOn(this.map);
        this.serial = title;
        this.indice = i;
        this.getData(this.serial, name);
      });
      // Añadir el marcador al grupo de clustering en lugar de directamente al mapa
      markerClusterGroup.addLayer(marker);
      // Añadir el grupo de clustering al mapa
      this.map.addLayer(markerClusterGroup);
    });
  }

  private async addInfoChannel(): Promise<void> {
    const ancLocations = this.locations.filter((location) =>
      isAncFamilyDevice({ sub_type: location.sub_type, serial: location.title })
    );

    if (!ancLocations.length) return;

    await Promise.all(
      ancLocations.map(
        (location) =>
          new Promise<void>((resolve) => {
            this._devices.getModuleInfo(location.title, 'channel').subscribe({
              next: (data) => {
                location.channelStat = data?.stat ?? null;
                resolve();
              },
              error: () => {
                location.channelStat = null;
                resolve();
              },
            });
          })
      )
    );
  }

  parseData(data) {
    if (typeof data === 'string') {
      return JSON.parse(data);
    } else {
      return data;
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.map && !this.showList) {
      setTimeout(() => this.map.invalidateSize(), 100);
    }
  }

  changeOption() {
    this._dashboardService.setModoDashboard(this.selectedSetting);
    this._dashboardService.setUpdateSidebar();

    if (this.selectedSetting == 'map') {
      localStorage.setItem('viewCurrent', `${this.selectedSetting}`);
      this.loading = true;
      this.showList = !this.showList;
      setTimeout(() => {
        this.loading = !this.loading;
        this.initMap();
      }, 1500);
    } else {
      if (this.data[0].subgroups === undefined) {
        this.getGroupsInfo(true);
      }
      this.homeClone = null;
      this.listClone = null;
      const oldMap = document.getElementById('map');
      if (oldMap && oldMap.parentNode) {
        oldMap.parentNode.removeChild(oldMap);
      }

      localStorage.setItem('viewCurrent', `${this.selectedSetting}`);
      this.info = false;
      this.loading = true;
      setTimeout(() => {
        this.loading = !this.loading;
        this.showList = true;
      }, 1000);
    }
  }

  getData(serial: string, name:string): void {

    if (!isRelaySchedulerSerial(serial) && !serial.startsWith('XLUM') && !serial.startsWith('CTM')) {
      this._devices.getMultiModules(serial, ['evsm', 'modulator', 'solar'], 'all', true).subscribe(data => {
        data.forEach(module => {

          switch (module.topic_name) {

            case "evsm":
              this.connectors = module.elements;
              this.connectors.forEach((conn, i) => {
                this.connectorsState[i] = conn.data.stat.state;
                if (this.statesPermission.includes(this.connectorsState[i]))
                  this.permission[i] = true;
                else this.permission[i] = false;
              });
              break;

            case "modulator":
              this.totalPower = module.stat.instPower;
              this.homePower = module.stat.homePower;
              this.evsePower = module.stat.evsePower;
              this.fvPower = module.stat.fvPower;
              if (module.stat.battEnergy < 0) {
                this.battEnergy = -1 * module.stat.battEnergy;
                this.batteryCharging = true;
              } else {
                this.battEnergy = module.stat.battEnergy;
                this.batteryCharging = false;
              }
              this.battPercent = module.stat.battPercent;
              break;

            case "solar":
              this.solarInfo = module;
              if (typeof this.solarInfo?.cfg?.inversor === 'string')
                this.solarInfo.cfg.inversor = JSON.parse(this.solarInfo.cfg.inversor);
              break;
            default:
              break;
          }
        });
      })
    };
    if (isRelaySchedulerSerial(serial) || serial.startsWith('XLUM')) {
      this._devices.getModuleInfo(serial, 'channel').subscribe(data => {
        this.channels = data.stat;
      })
    }


    setTimeout(() => {
      if(isRelaySchedulerSerial(serial) || serial.startsWith('XLUM')) {
        this.popup.setContent(name + `<br>` + `<small>` + serial + `</small>` + this.iconoANC);
      }
      else if(serial.startsWith('CTM')) {
        this.popup.setContent(name + `<br>` + `<small>` + serial + `</small>` + this.iconoCTM);
      }
      else{
        this.popup.setContent(name + `<br>` + `<small>` + serial + `</small>` + this.icono);
      }
      this.loadingInfo = false;
      this.info = true;
    }, 1500);
  }

  getTranslatedText(translationKey: string) {
    if (translationKey) return this._translate.instant(translationKey);
    else return null;
  }

  goToDevice(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}`);
  }
  goToSettings(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}/settings`);
  }

  goToDiagnosis(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}/diagnosis`);
  }

  isRelaySchedulerSerial(serial: string): boolean {
    return isRelaySchedulerSerial(serial);
  }

  getRelayDeviceImage(serial: string, subType?: string): string {
    return getRelayDeviceImage(serial, subType);
  }

  isAncFamilyLocation(index: number): boolean {
    const location = this.locations[index];
    return isAncFamilyDevice({ sub_type: location?.sub_type, serial: location?.title });
  }

  geolocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Permiso habilitado
          (this.position.lat = position.coords.latitude),
            (this.position.lng = position.coords.longitude);
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            // Permiso deshabilitado
            const idioma = navigator.language;
            switch (idioma) {
              case 'it-IT':
                (this.position.lat = 41.889099),
                  (this.position.lng = 12.490894);
                break;
              case 'da':
                (this.position.lat = 55.663301),
                  (this.position.lng = 12.579402);
                break;
              case 'nl':
                (this.position.lat = 52.371933), (this.position.lng = 4.892886);
                break;
              default:
                this.position = { lat: 40.45987, lng: -3.691145 };
                break;
            }
          }
        }
      );
    } else {
      console.log('El navegador no soporta la API de Geolocation');
    }
  }

  infoGroup(group) {
    this._dashboardService.setBreadCrumbs({
      name: group.name,
      alias: group.alias,
    });
    this._router.navigate(['/dashboard/group', group.alias]);
  }

  getLinkedDevices(subgrupoAlias) {
    !this.showDevices;
    this._devices.getLinkedDevices(subgrupoAlias).subscribe((data) => {
      this.linkedDevices = data;
    });
  }

  detailGroup(group) {
    this._dashboardService.setBreadCrumbs({
      name: group.name,
      alias: group.alias,
    });
    this._router.navigate(['/dashboard/group', group.alias, 'settings']);
  }
  viewGroup(group) {
    this._dashboardService.setBreadCrumbs({
      name: group.name,
      alias: group.alias,
    });
    this._router.navigate(['/dashboard/group', group.alias, 'view']);
  }

  goToSPL(group) {
    this._dashboardService.setBreadCrumbs({
      name: group.name,
      alias: group.alias,
    });
    this._router.navigate(['/dashboard/splconfig', group.alias]);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.data = this.dataSource.filter((item) => {
      // Comprueba si el nombre del grupo principal incluye el valor del filtro
      const matchesMainGroup = item.name.toLowerCase().includes(filterValue);

      // Comprueba si alguno de los subgrupos incluye el valor del filtro
      const matchesSubGroup = item.subgroups?.some((subgroup) =>
        subgroup.name.toLowerCase().includes(filterValue)
      );

      // Comprueba si alguno de los dispositivos incluye el valor del filtro por el campo serial (ignora mayúsculas/minúsculas)
      const matchesDevice = item.devices?.some((device) =>
        device.serial.toLowerCase().includes(filterValue)
      );

      // Devuelve true si hay coincidencia en el grupo principal, en cualquier subgrupo o en cualquier dispositivo
      return matchesMainGroup || matchesSubGroup || matchesDevice;
    });
  }

  // home() {
  //   this._dashboardService.setUpdateSidebar();
  //   // this.getAllDevices();
  //   this._dashboardService.setLocation(this.locations[0].position);
  //   this._dashboardService.setZoom(calculoZoom(this.locations));
  // }

  hasGroupSubscription(): boolean {
    return this._user.hasGroupsSubscription();
  }

  closeInfoPanel() {
    this.info = false;
    this.map.closePopup();
  }

  isCharger(): boolean {
    return this.serial.includes('EVVC') ? true : false;
  }


contactSupport(): void{
      const lang = this._translate.currentLang;
    let url = '';

    if (lang === 'es') {
      url = 'https://orbis.es/soporte-tecnico/';
    } else {
      url = 'https://orbis.es/en/technical-support/';
    }

    window.open(url, '_blank');

}

visitYoutube(): void{
    window.open('https://www.youtube.com/watch?v=BuvMMmDSDKA&list=PLK_sOVDO7MZX5PQO7l0he2GoJIUjbPAcG&index=2', '_blank');
  }

}
